<div class="relative box-baner">

  <div class="xl:hidden my-8 mx-4 flex justify-center">
    <a target="_blank" href="https://www.instagram.com/irani_expert/">
      <img loading="lazy" class="max-w-md rounded-2xl" src="../../../assets/img/instagram-adds.webp" alt="instagram-adds">
    </a>
  </div>

  <a class="hidden xl:block relative" target="_blank" href="https://www.instagram.com/irani_expert/">

    <img loading="lazy" class="rounded-3xl 2xl" src="../../../assets/img/instagram-adds-desctop.webp" alt="instagram-adds">
    <img loading="lazy" class="top-[4%] z-50 absolute the-person" src="../../../assets/img/instagram-adds-desctop-2.webp" alt="instagram-adds">

    <p class="absolute text-black text-center 2xl:w-56 font-black 2xl:!text-xs text-[0.68rem] w-48 top-[84%] left-[18%] 2xl:!left-[15%]">
      برای دیدن <span class="bg-[#43cc5a] rounded-md px-1">عملکرد ربات</span> و آخرین اخبار فارکس با ما در اینستگرام همراه باشید
    </p>

    <div class="flex justify-center w-full absolute top-[8%] left-[2%]">
      <div class="bg-[#f75b68] flex justify-around rounded-lg w-1/2 h-12">
        <div class="flex flex-col text-white items-center">
          <i class="scale-75 comment-icon w-7 aspect-square"></i>
          <span class="text-sm font-bold">{{ followersCount }}</span>
        </div>
          <div class="flex flex-col text-white items-center">
            <i class="scale-75 user-icon w-7 aspect-square"></i>      
            <span class="text-sm font-bold">{{ commentsCount }}</span>
          </div>
          <div class="flex flex-col text-white items-center">
            <i class="scale-75 like-icon w-7 aspect-square"></i>
            <span class="text-sm font-bold">{{ likesCount }}</span>
          </div>
      </div>
    </div>

  </a>
  
</div>

  